import {
  DatadogEnvironmentCode,
  EnvironmentCode,
  EnvironmentPlatform,
  EnvironmentTemplate
} from './environment-template';
import {getDbVersion} from 'src/environments/get-db-version';
import packageJson from 'package.json';

const HOSTNAME ='shop.europastry.com';
const PROTOCOL = 'https';

export const environment: EnvironmentTemplate = {
  isDevelopment: false,
  DEFAULT_EMAIL: '',
  DEFAULT_PASSWORD: '',
  ENVIRONMENT_CODE: EnvironmentCode.PRO,
  DATADOG_ENVIRONMENT_CODE: DatadogEnvironmentCode.PRO,
  API_BASE_URL: 'https://sapi.europastry.com/euro.sapi',
  ADYEN_CLIENT_CODE: 'live_NAGRJB4BYJFRDHTNBUGEHLII7UX67PYQ',
  ADYEN_ENVIRONMENT: 'live',
  HOSTNAME,
  PROTOCOL,
  PORT: '',
  //Google Tag Manager
  GTM_ID: 'GTM-5S95NLB',
  SITE_NAME: 'Europastry',
  BRAND_NAME: 'Europastry',
  BASE_URL: process.env.BASE_URL ?? `${PROTOCOL}://${HOSTNAME}`,
  PLATFORM: process.env.PLATFORM as EnvironmentPlatform | null ?? EnvironmentPlatform.WEB,
  PROJECT_VERSION: packageJson.version,
  DB_VERSION: getDbVersion(),
  SENTRY_DSN: 'https://b0936740e7794db7a72076c03b74ee59@o4504611191193600.ingest.sentry.io/4504808929558528',
  RECAPTCHA_SITE_KEY: '6LeE_D8aAAAAAJoDYBul2Ox8sDKvzQiS9S2_oka_',
  SITE: 'SAPI',
  APP_STORE_LINK: 'https://apps.apple.com/app/id910981869',
  GOOGLE_PLAY_LINK: 'http://play.google.com/store/apps/details?id=com.europastry.ecommerce',
  OPEN_APP_LINK: 'https://europastryecommerce.page.link/inicio',
  IS_PDF_CATALOG_ENABLED: false,
  APPLE_PAY_MERCHANT_IDENTIFIER: 'merchant.com.europastry.ecommerce',
  FIREBASE_WEB_APY_KEY: 'AIzaSyDPEPRlkLt9FUc_dYMoJECiGNF72GB29wA',
};